import {Component, inject, OnInit} from '@angular/core'
import {ActivatedRoute, Router, RouterLink} from '@angular/router'
import {DocumentService} from '../../services/document.service'
import {BorgoAuthSate, CodeInput} from '@sparbanken-syd/borgo-types'
import {catchError, NEVER} from 'rxjs'
import {HttpErrorResponse, HttpParams} from '@angular/common/http'
import {DOCUMENTS_ROUTE_PATH, KYC_ROUTE_PATH, LETTER_ROUTE_PATH, LOAN_ROUTE_PATH} from '../../application/data-types'
import {UserService} from '../../services/user.service'
import {MatExpansionPanel, MatExpansionPanelContent, MatExpansionPanelHeader} from '@angular/material/expansion'
import {ProgressNgComponent} from '../components/progress/progress-ng.component'


@Component({
  selector: 'spb-code',
  templateUrl: './code.component.html',
  styleUrls: ['./code.component.scss'],
  imports: [
    RouterLink,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelContent,
    ProgressNgComponent
  ]
})
export class CodeComponent implements OnInit {

  public error = false
  public errorMessage: string | undefined

  /**
   * This was introduced when I thought there was
   * a difference in paths. I leave it here in case
   */
  private readonly paths: Record<BorgoAuthSate, string[]> = {
    AUTH: [DOCUMENTS_ROUTE_PATH, 'userId'],
    AUTOGIRO: [DOCUMENTS_ROUTE_PATH, 'userId'],
    SIGN: [DOCUMENTS_ROUTE_PATH, 'userId'],
    LETTER: [LETTER_ROUTE_PATH, 'klar'],
    LOAN: [LOAN_ROUTE_PATH, 'start'], // Go back to start so that we can load data.
    KYC: [KYC_ROUTE_PATH, 'input'],
    KYC_UPDATE: [KYC_ROUTE_PATH, 'dokument', 'userId']
  }

  private readonly route = inject(ActivatedRoute)
  private readonly router = inject(Router)
  private readonly dataService = inject(DocumentService)
  private readonly userService = inject(UserService)

  ngOnInit(): void {

    const params = new HttpParams({fromString: this.route.snapshot.fragment as string})
    const request: CodeInput = {
      code: params.get('code') as string,
      state: params.get('state') as string
    }

    if (params.has('code')) {
      this.userService.code(request).pipe(
        catchError((err: HttpErrorResponse) => {
          this.error = true
          this.errorMessage = err.message
          return NEVER
        })
      ).subscribe(res => {
        const path = this.paths[res.state]
          .map(p => p.replace('userId', res.userId)
            .replace('null', ''))
        // If autogiro is registered, then we hide the autogiro.
        if (res.autogiro) {
          this.dataService.addToken(res.autogiro)
        }
        this.router.navigate(path.filter(Boolean), {queryParams: {context: res.context}}).then()

      })
    } else {
      this.error = true
      this.errorMessage = params.get('error_description') as string
    }
  }
}
